import { genericErrorProvider } from '../../store/providers/genericErrorProvider';

export const genericMessageHandler = (): void => {
  const { setGenericError } = genericErrorProvider();

  setGenericError('commonErrorMessage');
};

export const a11yFocusApiErrors = (props?: React.RefObject<HTMLDivElement>): void => {
  if (props?.current) {
    props.current.focus();
  }
};

export const isNotSpaceOrEnterKey = (event: React.KeyboardEvent | React.MouseEvent): boolean => {
  const isNotSpaceOrEnterKey =
    event.type === 'keyup' ||
    (event.type === 'keydown' &&
      !((event as React.KeyboardEvent).keyCode === 13 || (event as React.KeyboardEvent).keyCode === 32));
  return isNotSpaceOrEnterKey;
};
